/*
  buecherglanz — 2026-09-29
  Grund: Startseite „Maison 10/10“, Bereich „So funktionieren Grip & Insert“ (sections/bg-how-it-works.liquid).
  Funktion:
    · Reiter am Handy (WAI-ARIA Tabs): Klick und Pfeiltasten wechseln das Produkt; aria-selected/tabindex werden gepflegt.
    · Video: startet stumm erst, wenn es sichtbar ist, und pausiert ausserhalb; Pause-/Abspielen-Knopf (WCAG 2.2.2);
      bei „Bewegung reduzieren“ kein Autoplay — der Knopf zeigt dann „Abspielen“.
  Ohne JavaScript: alle Inhalte bleiben sichtbar (Desktop) bzw. das erste Produkt (Handy); das Video zeigt sein Standbild.
*/
(function () {
  if (customElements.get('bg-how-tabs')) return;

  class BgHowTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i, false));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(next, true);
        });
      });
      this.querySelectorAll('.bg-how__video').forEach((wrap) => this.initVideo(wrap));
    }

    select(index, focus) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        this.panels[i].classList.toggle('is-active', on);
      });
      if (focus) this.tabs[index].focus();
    }

    initVideo(wrap) {
      const video = wrap.querySelector('video');
      const btn = wrap.querySelector('.bg-how__pause');
      if (!video || !btn) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let userPaused = reduce;
      video.muted = true;

      const setLabel = () => {
        const playing = !video.paused;
        btn.classList.toggle('is-playing', playing);
        btn.setAttribute('aria-label', playing ? btn.dataset.labelPause : btn.dataset.labelPlay);
      };
      video.addEventListener('play', setLabel);
      video.addEventListener('pause', setLabel);
      btn.hidden = false;
      setLabel();

      btn.addEventListener('click', () => {
        if (video.paused) {
          userPaused = false;
          video.play().catch(() => {});
        } else {
          userPaused = true;
          video.pause();
        }
      });

      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !userPaused) {
            video.play().catch(() => {});
          } else if (!entry.isIntersecting && !video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.35 }).observe(video);
    }
  }

  customElements.define('bg-how-tabs', BgHowTabs);
})();
